import { useEffect } from 'react'
import { useLogin } from '@/features/authentication'

const usePostLogin = () => {
  const { onSuccessLogin } = useLogin()

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'login-success') {
        onSuccessLogin()
      }
    }

    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [onSuccessLogin])
}

export default usePostLogin
